import { Link } from "react-router-dom";

const articleCards = [
  {
    slug: "pandabuy-spreadsheet-guide",
    title: "The Ultimate Pandabuy Spreadsheet Guide: How to Find the Best Deals in 2026",
    excerpt: "Learn everything about using a Pandabuy spreadsheet to discover hidden gems, compare prices, and shop smarter. Our complete guide covers spreadsheet structure, quality ratings, and pro tips for beginners.",
    category: "Guide",
    readTime: "12 min read",
    imageUrl: "https://readdy.ai/api/search-image?query=Minimalist%20desk%20setup%20with%20laptop%20displaying%20spreadsheet%20data%20and%20fashion%20product%20images%20surrounding%20sneakers%20and%20clothing%20items%20on%20a%20clean%20white%20desk%20soft%20natural%20lighting%20warm%20cream%20background%20editorial%20lifestyle%20photography%20modern%20aesthetic%20professional%20organized%20composition&width=800&height=560&seq=card-v2-guide&orientation=landscape",
  },
  {
    slug: "pandabuy-sneakers-spreadsheet",
    title: "Best Pandabuy Sneakers Spreadsheet: Top Jordan, Nike & Yeezy Finds for 2026",
    excerpt: "Discover the ultimate sneaker spreadsheet with curated Jordan, Nike, Dunk, and Yeezy finds. Quality-checked, price-compared, and updated weekly for the best sneaker deals on Pandabuy.",
    category: "Sneakers",
    readTime: "7 min read",
    imageUrl: "https://readdy.ai/api/search-image?query=Clean%20product%20photography%20of%20three%20pairs%20of%20trendy%20white%20cream%20and%20grey%20sneakers%20arranged%20artfully%20on%20a%20light%20concrete%20surface%20soft%20natural%20daylight%20gentle%20shadows%20warm%20neutral%20backdrop%20editorial%20fashion%20aesthetic%20minimal%20composition&width=800&height=560&seq=card-v2-sneakers&orientation=landscape",
  },
  {
    slug: "pandabuy-streetwear-spreadsheet",
    title: "Pandabuy Streetwear Spreadsheet: Hoodies, Tees & Essentials Guide 2026",
    excerpt: "The complete streetwear spreadsheet guide covering Stussy, Essentials, Supreme, and more. Find the best hoodies, graphic tees, and streetwear staples at unbeatable prices on Pandabuy.",
    category: "Streetwear",
    readTime: "8 min read",
    imageUrl: "https://readdy.ai/api/search-image?query=Minimal%20editorial%20photography%20of%20stylish%20streetwear%20essentials%20oversized%20hoodie%20graphic%20tee%20and%20cargo%20pants%20laid%20out%20on%20a%20light%20wooden%20floor%20soft%20natural%20daylight%20warm%20neutral%20tones%20clean%20aesthetic%20high%20fabric%20detail&width=800&height=560&seq=card-v2-streetwear&orientation=landscape",
  },
  {
    slug: "pandabuy-budget-spreadsheet",
    title: "Pandabuy Budget Spreadsheet: Best Finds Under $50 That Actually Look Expensive",
    excerpt: "Discover the best budget finds in our spreadsheet — sneakers, clothing, and accessories under $50 that deliver premium quality. Shop smarter and save more with verified budget picks.",
    category: "Budget",
    readTime: "6 min read",
    imageUrl: "https://readdy.ai/api/search-image?query=Minimal%20lifestyle%20photography%20of%20affordable%20yet%20stylish%20fashion%20items%20clean%20sneakers%20basic%20tee%20and%20accessories%20arranged%20on%20a%20light%20wooden%20surface%20with%20price%20tags%20visible%20soft%20natural%20lighting%20warm%20cream%20backdrop%20editorial%20aesthetic&width=800&height=560&seq=card-v2-budget&orientation=landscape",
  },
  {
    slug: "pandabuy-spreadsheet-vs-manual",
    title: "Pandabuy Spreadsheet vs Manual Link Hunting: Why Organized Sheets Win Every Time",
    excerpt: "Data-driven comparison between using a Pandabuy spreadsheet and hunting for links manually. See the time savings, quality improvements, and cost benefits of organized shopping on Pandabuy.",
    category: "Comparison",
    readTime: "5 min read",
    imageUrl: "https://readdy.ai/api/search-image?query=Split%20screen%20concept%20editorial%20photography%20left%20side%20showing%20disorganized%20scattered%20papers%20right%20side%20showing%20clean%20organized%20digital%20spreadsheet%20on%20tablet%20with%20fashion%20accessories%20warm%20neutral%20background%20soft%20lighting%20minimal%20modern&width=800&height=560&seq=card-v2-compare&orientation=landscape",
  },
  {
    slug: "pandabuy-spreadsheet-safety",
    title: "Pandabuy Spreadsheet Safety Guide: How to Avoid Scams and Shop Securely in 2026",
    excerpt: "Complete safety guide for using Pandabuy spreadsheets. Learn how to spot scams, verify sellers, protect your payments, and shop with complete confidence on Pandabuy in 2026.",
    category: "Safety",
    readTime: "9 min read",
    imageUrl: "https://readdy.ai/api/search-image?query=Minimal%20editorial%20photography%20of%20a%20secure%20shopping%20concept%20with%20laptop%20displaying%20shield%20icon%20and%20verified%20badge%20alongside%20shopping%20bags%20on%20a%20clean%20desk%20soft%20natural%20lighting%20warm%20neutral%20tones%20professional%20aesthetic&width=800&height=560&seq=card-v2-safety&orientation=landscape",
  },
  {
    slug: "pandabuy-first-haul-guide",
    title: "How to Use a Pandabuy Spreadsheet for Your First Haul: A Beginner Step-by-Step Guide",
    excerpt: "Step-by-step beginner guide to using a Pandabuy spreadsheet for your first shopping haul. Learn how to navigate categories, choose items, and place your first order with confidence on Pandabuy.",
    category: "Beginner",
    readTime: "10 min read",
    imageUrl: "https://readdy.ai/api/search-image?query=Warm%20inviting%20editorial%20photography%20of%20beginner%20setting%20up%20first%20shopping%20session%20laptop%20open%20to%20spreadsheet%20notebook%20with%20handwritten%20notes%20and%20fashion%20magazines%20nearby%20on%20cozy%20desk%20soft%20natural%20light%20warm%20neutral%20palette&width=800&height=560&seq=card-v2-beginner&orientation=landscape",
  },
  {
    slug: "pandabuy-hidden-gems",
    title: "Pandabuy Spreadsheet Hidden Gems: 15 Underrated Finds You Are Missing Out On",
    excerpt: "Uncover the best hidden gems in our Pandabuy spreadsheet — underrated sneakers, clothing, and accessories that deliver incredible quality for the price. Find what others are overlooking.",
    category: "Hidden Gems",
    readTime: "7 min read",
    imageUrl: "https://readdy.ai/api/search-image?query=Artistic%20minimal%20photography%20of%20unique%20and%20unexpected%20fashion%20finds%20distinctive%20accessory%20piece%20textured%20fabric%20item%20and%20stylish%20footwear%20arranged%20on%20light%20textured%20surface%20soft%20dramatic%20natural%20lighting%20warm%20neutral%20backdrop%20editorial&width=800&height=560&seq=card-v2-gems&orientation=landscape",
  },
  {
    slug: "pandabuy-luxury-alternatives",
    title: "Pandabuy Luxury Alternatives Spreadsheet: Premium Style Without the Premium Price Tag",
    excerpt: "Explore the best luxury alternatives in our Pandabuy spreadsheet — designer-inspired bags, accessories, and clothing that deliver premium aesthetics at a fraction of the retail cost on Pandabuy.",
    category: "Luxury",
    readTime: "8 min read",
    imageUrl: "https://readdy.ai/api/search-image?query=Elegant%20minimal%20product%20photography%20of%20luxury%20style%20accessories%20structured%20leather%20bag%20silk%20scarf%20and%20minimal%20watch%20arranged%20on%20marble%20surface%20with%20soft%20natural%20daylight%20refined%20shadows%20warm%20cream%20backdrop%20editorial%20luxury%20aesthetic&width=800&height=560&seq=card-v2-luxury&orientation=landscape",
  },
  {
    slug: "pandabuy-tiktok-viral",
    title: "Pandabuy Spreadsheet TikTok Viral Finds: The Hottest Products Trending Right Now",
    excerpt: "Stay ahead of the trends with our TikTok viral finds spreadsheet. Discover the products taking over social media before they sell out on Pandabuy — updated daily with the latest trending items.",
    category: "Trending",
    readTime: "6 min read",
    imageUrl: "https://readdy.ai/api/search-image?query=Vibrant%20minimal%20editorial%20photography%20of%20trending%20social%20media%20fashion%20items%20colorful%20sneakers%20statement%20hoodie%20and%20eye-catching%20accessories%20arranged%20on%20clean%20white%20surface%20soft%20natural%20lighting%20warm%20accents%20modern%20trendy%20aesthetic&width=800&height=560&seq=card-v2-tiktok&orientation=landscape",
  },
  {
    slug: "pandabuy-spreadsheet-update-guide",
    title: "How Often Pandabuy Spreadsheets Are Updated and Why Freshness Matters in 2026",
    excerpt: "Learn why spreadsheet update frequency is critical for Pandabuy shopping success. Our guide explains how daily updates, dead link removal, and real-time price tracking work on Pandabuy.",
    category: "Guide",
    readTime: "5 min read",
    imageUrl: "https://readdy.ai/api/search-image?query=Clean%20minimal%20editorial%20photography%20of%20calendar%20and%20clock%20concept%20with%20laptop%20showing%20refresh%20icon%20and%20data%20charts%20alongside%20fashion%20items%20on%20light%20desk%20soft%20natural%20daylight%20warm%20neutral%20palette%20professional%20organized&width=800&height=560&seq=card-v2-updates&orientation=landscape",
  },
  {
    slug: "pandabuy-seller-ratings",
    title: "Understanding Pandabuy Spreadsheet Seller Ratings: How to Pick the Best Sellers",
    excerpt: "Master the art of reading seller ratings in Pandabuy spreadsheets. Learn how transaction history, dispute rates, and community feedback help you choose reliable sellers every time.",
    category: "Tips",
    readTime: "6 min read",
    imageUrl: "https://readdy.ai/api/search-image?query=Minimal%20editorial%20photography%20of%20a%20rating%20and%20review%20concept%20with%20star%20ratings%20displayed%20on%20a%20laptop%20screen%20alongside%20shopping%20packages%20and%20products%20on%20a%20clean%20desk%20soft%20natural%20lighting%20warm%20neutral%20background%20professional%20aesthetic&width=800&height=560&seq=card-v2-sellers&orientation=landscape",
  },
];

export default function ArticleCards() {
  return (
    <section id="articles" className="relative py-24 md:py-32 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-8">
        {/* Section Header */}
        <div className="flex flex-col lg:flex-row lg:items-end justify-between mb-16 gap-6">
          <div>
            <p className="text-[12px] font-label font-semibold tracking-[0.2em] text-foreground-500 uppercase mb-4">
              Latest Guides
            </p>
            <h2 className="font-heading text-[42px] md:text-[52px] leading-[1.08] text-foreground-950 font-bold tracking-[-0.02em]">
              Pandabuy Spreadsheet
              <br />
              Tips &amp; Guides
            </h2>
          </div>
          <Link
            to="/article/pandabuy-spreadsheet-guide"
            className="inline-flex items-center gap-2 text-[14px] font-label font-semibold text-foreground-700 hover:text-foreground-950 transition-colors duration-200 whitespace-nowrap cursor-pointer"
          >
            View All Articles
            <i className="ri-arrow-right-line text-sm"></i>
          </Link>
        </div>

        {/* Article Cards - 12 total */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {articleCards.map((article) => (
            <Link
              key={article.slug}
              to={`/article/${article.slug}`}
              onClick={() => window.scrollTo({ top: 0, behavior: "instant" })}
              className="group bg-background-50 rounded-2xl border border-background-200/60 overflow-hidden transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_16px_48px_rgba(0,0,0,0.06)] cursor-pointer"
            >
              <div className="relative w-full h-[200px] overflow-hidden">
                <img
                  src={article.imageUrl}
                  alt={article.title}
                  title={article.title}
                  className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
                />
              </div>
              <div className="p-5 md:p-6">
                <div className="flex items-center gap-3 mb-3">
                  <span className="text-[11px] font-label font-semibold text-accent-600 bg-accent-50 px-2.5 py-1 rounded-full uppercase tracking-wider">
                    {article.category}
                  </span>
                  <span className="text-[12px] text-foreground-400 font-body">
                    {article.readTime}
                  </span>
                </div>
                <h3 className="text-[16px] md:text-[17px] font-heading font-bold text-foreground-900 leading-snug group-hover:text-primary-600 transition-colors duration-300 line-clamp-2">
                  {article.title}
                </h3>
                <p className="mt-2 text-[13px] text-foreground-500 leading-relaxed font-body line-clamp-2">
                  {article.excerpt}
                </p>
                <div className="mt-4 flex items-center gap-1.5 text-[13px] font-label font-semibold text-foreground-400 group-hover:text-primary-500 transition-colors duration-300">
                  <span>Read Article</span>
                  <i className="ri-arrow-right-line text-xs"></i>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}